/**
 * Front page: hide fixed .front-page__scroll-down when the footer enters the bottom
 * of the viewport so the control does not stack on top of the footer.
 */
(function () {
	'use strict';

	var btn = document.querySelector('.front-page .front-page__scroll-down');
	var footer = document.querySelector('footer.footer');
	if (!btn || !footer) {
		return;
	}

	/** Distance from viewport bottom — hide when footer top crosses above this line */
	var bottomClearancePx = 110;

	function update() {
		var vh = window.innerHeight || document.documentElement.clientHeight || 800;
		var line = vh - bottomClearancePx;
		var hide = footer.getBoundingClientRect().top < line;
		btn.classList.toggle('front-page__scroll-down--hidden', hide);
	}

	window.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update, { passive: true });

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', update);
	} else {
		update();
	}

	var lenisTries = 0;
	var maxLenisTries = 80;
	function hookLenis() {
		var L = window.evonaLenis;
		if (L && typeof L.on === 'function') {
			L.on('scroll', update);
			return;
		}
		lenisTries++;
		if (lenisTries < maxLenisTries) {
			setTimeout(hookLenis, 50);
		}
	}
	hookLenis();
})();
